import React, { useState, useEffect } from "react";
import { NavLink, Link, useLocation, useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";

function Header() {
  const { t, lang, toggleLang, theme, toggleTheme } = useApp();
  const [open, setOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [query, setQuery] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setOpen(false);
    try { setUser(JSON.parse(localStorage.getItem("spar_user") || "null")); }
    catch { setUser(null); }
  }, [location]);

  const logout = () => {
    localStorage.removeItem("spar_token");
    localStorage.removeItem("spar_user");
    setUser(null);
    navigate("/");
  };

  const doSearch = (e) => {
    e.preventDefault();
    const q = query.trim();
    if (q) { navigate(`/search?q=${encodeURIComponent(q)}`); setQuery(""); setOpen(false); }
  };

  const NAV_LINKS = (
    <>
      <li><NavLink to="/" end onClick={() => setOpen(false)}>{t("home")}</NavLink></li>
      <li><NavLink to="/artists" onClick={() => setOpen(false)}>{t("artists")}</NavLink></li>
      <li><NavLink to="/gallery" onClick={() => setOpen(false)}>{t("gallery")}</NavLink></li>
      <li><NavLink to="/events" onClick={() => setOpen(false)}>{lang === "ar" ? "الإعلام والفعاليات" : "Media & Events"}</NavLink></li>
      <li><NavLink to="/news" onClick={() => setOpen(false)}>{lang === "ar" ? "الأخبار" : "News"}</NavLink></li>
      <li><NavLink to="/art-news" onClick={() => setOpen(false)}>{lang === "ar" ? "أخبار الفن" : "Art News"}</NavLink></li>
      <li><NavLink to="/about" onClick={() => setOpen(false)}>{t("about")}</NavLink></li>
      <li><a href="https://spar-hub.org/Forum" target="_blank" rel="noopener noreferrer" style={{ color: "var(--primary)", fontWeight: 700 }} onClick={() => setOpen(false)}>{lang === "ar" ? "منتدى SPAR" : "SPAR Forum"}</a></li>
    </>
  );

  return (
    <header className={`site-header ${open ? "open" : ""}`}>
      {/* ── Main bar (always visible) ── */}
      <div className="bar">
        <Link to="/" className="brand">
          <img src="/Logoithad.jpg" alt="SPAU logo" />
          <span className="brand-text">
            {lang === "ar" ? "الاتحاد التشكيلي" : "SPAU"}
            <small>{lang === "ar" ? "الاتحاد العام للفنانين التشكيليين السودانيين" : "Sudanese Plastic Artists Union"}</small>
          </span>
        </Link>

        {/* Desktop nav — hidden on mobile */}
        <nav className="desktop-nav">
          <ul className="nav-links">{NAV_LINKS}</ul>
        </nav>

        {/* Desktop search — hidden on mobile */}
        <form className="search-bar desktop-search" onSubmit={doSearch}>
          <span style={{ position: "absolute", left: 14, color: "var(--muted)", fontSize: "0.9rem", pointerEvents: "none" }}>
            <i className="fa-solid fa-magnifying-glass" />
          </span>
          <input
            style={{ padding: "9px 16px 9px 40px", border: "1.5px solid var(--line)", borderRadius: 999, fontSize: "0.9rem", background: "var(--cream)", color: "var(--ink)", width: 200, outline: "none", fontFamily: "inherit" }}
            placeholder={t("searchPlaceholder")}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </form>

        {/* Right tools — toggles always visible, auth + hamburger conditional */}
        <div className="bar-tools">
          <button className="icon-btn" onClick={toggleTheme} title={t("darkMode")}>
            <i className={`fa-solid ${theme === "dark" ? "fa-sun" : "fa-moon"}`} />
          </button>
          <button className="icon-btn lang-btn" onClick={toggleLang}>
            {lang === "en" ? "عربي" : "EN"}
          </button>

          {/* Auth — desktop only (mobile puts these in the panel) */}
          <div className="desktop-auth">
            {user ? (
              <>
                <Link className="btn btn-outline" to="/dashboard">{t("dashMyDashboard")}</Link>
                <button className="btn btn-outline" onClick={logout}>{t("logout")}</button>
              </>
            ) : (
              <>
                <Link className="btn btn-outline" to="/login">{t("login")}</Link>
                <Link className="btn btn-primary" to="/register">{t("join")}</Link>
              </>
            )}
          </div>

          {/* Hamburger — mobile only */}
          <button className="nav-toggle" aria-label="Menu" onClick={() => setOpen((o) => !o)}>
            <i className={`fa-solid ${open ? "fa-xmark" : "fa-bars"}`} />
          </button>
        </div>
      </div>

      {/* ── Mobile panel (slides down when open) ── */}
      <div className="nav-panel">
        <ul className="nav-links">{NAV_LINKS}</ul>

        <form className="mobile-search" onSubmit={doSearch}>
          <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", color: "var(--muted)", fontSize: "0.9rem", pointerEvents: "none" }}>
            <i className="fa-solid fa-magnifying-glass" />
          </span>
          <input
            style={{ width: "100%", padding: "10px 16px 10px 40px", border: "1.5px solid var(--line)", borderRadius: 999, fontSize: "0.95rem", background: "var(--surface)", color: "var(--ink)", outline: "none", fontFamily: "inherit" }}
            placeholder={t("searchPlaceholder")}
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </form>

        <div className="panel-auth">
          {user ? (
            <>
              <Link className="btn btn-outline btn-block" to="/dashboard" onClick={() => setOpen(false)}>{t("dashMyDashboard")}</Link>
              <button className="btn btn-outline btn-block" onClick={logout}>{t("logout")}</button>
            </>
          ) : (
            <>
              <Link className="btn btn-outline btn-block" to="/login" onClick={() => setOpen(false)}>{t("login")}</Link>
              <Link className="btn btn-primary btn-block" to="/register" onClick={() => setOpen(false)}>{t("join")}</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
